/* Lite YouTube embed — injects the real iframe only when the poster is clicked.
   Delegated + guarded so the script can be included by several sections safely. */
(function () {
  if (window.__ameYtLiteBound) return;
  window.__ameYtLiteBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yt-lite-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-yt-lite]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-video-id');
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = btn.getAttribute('aria-label') || 'Video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.className = 'ame-yt-lite__iframe';
    btn.replaceWith(iframe);
    iframe.focus();
  });
})();
